export default __webpack_public_path__ + "static/media/kelly.d9670782.jpeg";